<template>
  <div>
    <b-row>
      <b-card-code
        title="Vouchers"
        class="col-12"
      >
        Fahrzeug: {{this.NumberPlate}}
      </b-card-code>
      <b-card-code
        title="Diesel"
        class="col-12"
      >
        <div id="chartFuel"></div>
      </b-card-code>
      <b-card-code
        title="Vouchers"
        class="col-12"
      >
        <div id="chartVouchers"></div>
      </b-card-code>
      <b-card-code
        title="Umsatz"
        class="col-12"
      >
        <div id="chartSales"></div>
      </b-card-code>
    </b-row>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'
import BCardCode from '@core/components/b-card-code'
export default {
  name: 'VehicleStats',
  components: { BCardCode },
  async created() {
    await this.LoadCustomers();
    await this.LoadCustomerSales();
    await this.LoadFuel();
  },
  methods: {
    async LoadCustomers() {
      let vehicleCustomerData = {
        chart: {
          height: 650,
          type: "treemap",
        },
        series: [
          {
            data: [],
          },
        ]
      }

      // Update the chart data with API response
      const resp = await this.$http.get('statistics/customers/1/' + this.$route.params.id);
      if (resp.data.success) {
        vehicleCustomerData.series[0].data = resp.data.statistics.map(i => {
          return {
            x: i.Value.CustomerName,
            y: i.Value.Vouchers
          }
        });
        this.NumberPlate = resp.data.vehicle.NumberPlate
      }

      let chart = new ApexCharts(document.querySelector("#chartVouchers"), vehicleCustomerData);
      chart.render();
    },
    async LoadCustomerSales() {
      let Data = {
        chart: {
          height: 650,
          type: "treemap",
        },
        series: [
          {
            data: [],
          },
        ]
      }

      // Update the chart data with API response
      const resp = await this.$http.get('statistics/customers/1/' + this.$route.params.id);
      if (resp.data.success) {
        Data.series[0].data = resp.data.statistics.map(i => {
          return {
            x: i.Value.CustomerName + " ("+i.Value.SalesVolume.toFixed(2)+"€)",
            y: i.Value.SalesVolume
          }
        });
      }

      let chart = new ApexCharts(document.querySelector("#chartSales"), Data);
      chart.render();
    },
    async LoadFuel() {
      let Data = {
        chart: {
          height: 650,
          type: "area",
        },
        series: [
          {
            name: 'Diesel',
            data: []
          },
        ],
        xaxis: {
          type: 'datetime',
          categories: []
        },
        tooltip: {
          x: {
            format: 'dd.MM.yy HH:mm'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
      }

      // Update the chart data with API response
      const resp = await this.$http.get('statistics/vehicle/tracks/' + this.$route.params.id);
      if (resp.data.success) {
        resp.data.statistics.forEach(i => {
          Data.series[0].data.push(i.FuelLevel.toFixed(0));
          Data.xaxis.categories.push(i.DateTime);
        })
      }

      let chart = new ApexCharts(document.querySelector("#chartFuel"), Data);
      chart.render();
    }
  },
  data() {
    return {
      NumberPlate: ''
    }
  }
}
</script>

<style scoped>

</style>